export function defaultPackageName(localPackage) {
      
    const queryDefn = localPackage.params;
    const locations = localPackage.locations;
    if (!queryDefn || !locations || !locations.length) return null;
    var name = locations[0].name || locations[0].location;
    if (!name) name = "Unknown Location";
    name = (name.length < 25 && name) || (name.substring(0, 25) + "...");
    if (locations > 1) name = name + " " + locations.length + " more";
    if (queryDefn.startdate) name = name + " " + queryDefn.startdate;
    if (queryDefn.enddate) name = name + " to " + queryDefn.enddate;
    return name;
}

export function invalidPackageMessage(localPackage) {
      if (localPackage.locations.length === 0) return "No valid locations selected.";
      return null;
}

